export const IsTyping = () => {
    return (
        <div className="is-typing mx-2" data-testid="is-typing">
            <span></span>
            <span></span>
            <span></span>
        </div>
    );
};
